import React, { useEffect, useState, useRef } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { TrendingUpIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface BrandTopRatedProps {
  brandSlug: string;
}
export function BrandTopRated({
  brandSlug
}: BrandTopRatedProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);
  const products = [{
    id: 7,
    name: 'Slow Age Night Cream',
    brand: 'Vichy',
    price: 159.99,
    originalPrice: 199.99,
    discount: 20,
    rating: 4.9,
    reviewCount: 1456,
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=600',
    isBestSeller: true,
    expressDelivery: true
  }, {
    id: 8,
    name: 'Purete Thermale Cleansing Gel',
    brand: 'Vichy',
    price: 99.99,
    originalPrice: 129.99,
    discount: 23,
    rating: 4.8,
    reviewCount: 1123,
    image: 'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=600',
    expressDelivery: true
  }, {
    id: 9,
    name: 'Neovadiol Rose Platinum Eyes',
    brand: 'Vichy',
    price: 169.99,
    originalPrice: 219.99,
    discount: 23,
    rating: 4.9,
    reviewCount: 892,
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600',
    expressDelivery: true
  }, {
    id: 10,
    name: 'Ideal Soleil Bronze Spray SPF 50',
    brand: 'Vichy',
    price: 119.99,
    originalPrice: 149.99,
    discount: 20,
    rating: 4.7,
    reviewCount: 734,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=600',
    expressDelivery: true
  }, {
    id: 11,
    name: 'Liftactiv Collagen Specialist',
    brand: 'Vichy',
    price: 189.99,
    originalPrice: 239.99,
    discount: 21,
    rating: 4.8,
    reviewCount: 1067,
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=600',
    expressDelivery: true
  }, {
    id: 12,
    name: 'Mineral 89 Eyes',
    brand: 'Vichy',
    price: 129.99,
    originalPrice: 169.99,
    discount: 24,
    rating: 4.9,
    reviewCount: 945,
    image: 'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=600',
    expressDelivery: true
  }];
  const itemsPerView = isMobile ? 2 : isTablet ? 3 : 6;
  const totalSlides = Math.ceil(products.length / itemsPerView);
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      const slideWidth = scrollContainerRef.current.offsetWidth;
      const newSlide = Math.round(scrollLeft / slideWidth);
      setCurrentSlide(newSlide);
    }
  };
  const scrollToSlide = (index: number) => {
    if (scrollContainerRef.current) {
      const slideWidth = scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
    }
  };
  const scrollPrev = () => {
    const newSlide = Math.max(currentSlide - 1, 0);
    scrollToSlide(newSlide);
  };
  const scrollNext = () => {
    const newSlide = Math.min(currentSlide + 1, totalSlides - 1);
    scrollToSlide(newSlide);
  };
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1373" data-mp="zty9wl0befpq">
      <div className="flex items-center gap-3 mb-6" data-id="element-1374" data-mp="276yn92h163si">
        <div className="rounded-lg bg-sage-light p-3" data-id="element-1375" data-mp="2789td8xy7nms">
          <TrendingUpIcon className="h-6 w-6 text-sage-dark" data-id="element-1376" data-mp="2b6r03rdgiw3o" />
        </div>
        <div data-id="element-1377" data-mp="29q3dexx8utnn">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1378" data-mp="29ptprgzo8yl4">
            Top Rated Products
          </h2>
          <p className="text-gray-600" data-id="element-1379" data-mp="24stpxntf0s2g">Loved by our customers</p>
        </div>
      </div>
      {/* Mobile/Tablet Slider */}
      {isMobile || isTablet ? <div className="relative" role="region" aria-label="Top Rated Products" data-id="element-1380" data-mp="2epzi6zdrmp49">
          <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 md:gap-4" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-1381" data-mp="2es2fm4h8zkj0">
            {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
          width: isMobile ? 'calc(50% - 6px)' : 'calc(33.333% - 11px)'
        }} data-id="element-1382" data-mp="3bfyr4uxtvpnd">
                <EnhancedProductCard product={product} data-id="element-1383" data-mp="3q3qndlc32zhl" />
              </div>)}
          </div>
          {/* Navigation Arrows */}
          {totalSlides > 1 && <>
              <button onClick={scrollPrev} disabled={currentSlide === 0} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed z-10" aria-label="Previous products" data-id="element-1384" data-mp="3h0xy1nmgoxue">
                <ChevronLeftIcon className="w-6 h-6 text-gray-900" data-id="element-1385" data-mp="2ybrninvtncjo" />
              </button>
              <button onClick={scrollNext} disabled={currentSlide === totalSlides - 1} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed z-10" aria-label="Next products" data-id="element-1386" data-mp="32d36iak6wziw">
                <ChevronRightIcon className="w-6 h-6 text-gray-900" data-id="element-1387" data-mp="yy17kiid3chw" />
              </button>
            </>}
          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-1388" data-mp="q4xvoend77pd">
            {Array.from({
          length: totalSlides
        }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1389" data-mp="1hv2azyw9p4jq" data-mpi={index} />)}
          </div>
        </div> /* Desktop Grid */ : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1390" data-mp="13xdsuytl4bid">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-1391" data-mp="3olicdk05gac5" />)}
        </div>}
      <style jsx data-id="element-1392" data-mp="3ehlbpzkxr3io">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
}